import React, { useEffect, useRef, useState } from 'react';
import { drawLiquiditySegmentChart } from '../utils/chartUtils';

const LiquiditySegmentChart = ({ liquidityInfo }) => {
  const canvasRef = useRef(null);
  const [hasError, setHasError] = useState(false);
  const [chartDimensions, setChartDimensions] = useState({ width: 600, height: 300 });
  const containerRef = useRef(null);
  
  // Function to handle resize and maintain aspect ratio
  const updateDimensions = () => {
    if (containerRef.current) {
      const containerWidth = containerRef.current.clientWidth;
      const newHeight = Math.floor(containerWidth * 0.5); // 2:1 aspect ratio
      setChartDimensions({ width: containerWidth, height: newHeight });
    }
  };
  
  // Initialize and handle resize
  useEffect(() => {
    updateDimensions();
    window.addEventListener('resize', updateDimensions);
    
    return () => {
      window.removeEventListener('resize', updateDimensions);
    };
  }, []);
  
  useEffect(() => {
    try {
      if (!liquidityInfo || !liquidityInfo.liquidssegments || liquidityInfo.liquidssegments.length === 0) {
        return;
      }
      
      const canvas = canvasRef.current;
      if (!canvas) return;
      
      drawLiquiditySegmentChart(canvas, liquidityInfo);
      console.log(liquidityInfo);
    } catch (error) {
      console.error('Error rendering liquidity chart:', error);
      setHasError(true);
    }
  }, [liquidityInfo, chartDimensions]);
  
  if (hasError) {
    return (
      <div style={{ 
        marginTop: '10px',
        padding: '10px',
        backgroundColor: '#fff3cd',
        borderRadius: '5px',
        border: '1px solid #ffeeba'
      }}>
      </div>
    );
  }
  
  return (
    <div style={{ 
      marginTop: '10px',
      padding: '10px',
      backgroundColor: '#e8f5e8',
      borderRadius: '5px',
      border: '1px solid #c3e6cb',
    }}>
      <h4 style={{ color: '#155724', margin: '0 0 10px 0', fontSize: '14px' }}>
        📊 流动性分布图
      </h4>
      <div ref={containerRef} style={{width: '100%', maxWidth: '800px', margin: '0 auto',zIndex:1000}}>
        <canvas 
          ref={canvasRef} 
          width={chartDimensions.width}
          height={chartDimensions.height}
          style={{width: '100%', height: 'auto',pointerEvents:'auto'}}
        />
      </div>
    
    </div>
  );
};

// Higher order component for error boundary
const ErrorBoundaryWrapper = (props) => {
  try {
    return <LiquiditySegmentChart {...props} />;
  } catch (error) {
    console.error('Error in LiquiditySegmentChart:', error);
    return (
      <div style={{ 
        marginTop: '10px',
        padding: '10px',
        backgroundColor: '#fff3cd',
        borderRadius: '5px',
        border: '1px solid #ffeeba'
      }}>
    
      </div>
    );
  }
};

export default ErrorBoundaryWrapper; 